import { useFormContext, useWatch } from 'react-hook-form'
import { Box } from '@mui/material'

import { Button } from '@components/shared/Button'
import { CloseIcon } from '@assets/svgs/CloseIcon'
import { FilterIcon } from '@assets/svgs/FilterIcon'
import { RowBox } from '@components/shared/RowBox'
import { MultiSelect } from '@components/shared/MultiSelect'

import type { DetailedPreviewFiltersProps } from './types'

import * as S from './styles'

const ACCOUNT_ORDER = [
  'Faturamento',
  'Consumo',
  'Pessoal',
  'Depreciação',
  'Outras Despesas',
  'Bonificação'
]

const sortAccountsByOrder = (aLabel: string, bLabel: string) => {
  const indexA = ACCOUNT_ORDER.indexOf(aLabel)
  const indexB = ACCOUNT_ORDER.indexOf(bLabel)

  const isAInOrder = indexA !== -1
  const isBInOrder = indexB !== -1

  if (!isAInOrder && !isBInOrder) {
    return aLabel.localeCompare(bLabel)
  }

  if (!isAInOrder) return 1
  if (!isBInOrder) return -1

  return indexA - indexB
}

export const DetailedPreviewFilters = ({
  consolidatedPreviewFiltersData,
  consolidatedPreviewFiltersLoading,
  onConsolidatedPreviewDetailsFilters,
  getInitialConsolidatedPreviewFilters,
  onClearConsolidatedPreviewFilters
}: DetailedPreviewFiltersProps) => {
  const { control, reset } = useFormContext()

  const bigNumbersFiltersFormValues = useWatch({ control, name: 'bigNumbersFilters' })

  const handleResetFilters = () => {
    reset({
      bigNumbersFilters: bigNumbersFiltersFormValues,
      consolidatedPreviewFilters: getInitialConsolidatedPreviewFilters()
    })
  }

  return (
    <RowBox columns={4} style={{ marginBottom: 24 }}>
      <MultiSelect
        name="consolidatedPreviewFilters.account"
        label="Conta"
        placeholder="Selecione..."
        options={
          consolidatedPreviewFiltersData?.account
            ?.map((item) => ({
              label: item.name,
              value: item.code
            }))
            .sort((a, b) => sortAccountsByOrder(a.label, b.label)) || []
        }
        loading={consolidatedPreviewFiltersLoading}
      />
      <MultiSelect
        name="consolidatedPreviewFilters.weeks"
        label="Semana"
        placeholder="Selecione..."
        options={
          consolidatedPreviewFiltersData?.weeks?.map((item) => ({
            label: item.name,
            value: item.code
          })) || []
        }
        loading={consolidatedPreviewFiltersLoading}
      />
      <MultiSelect
        name="consolidatedPreviewFilters.deviationType"
        label="Tipo de Desvio"
        placeholder="Selecione..."
        options={
          consolidatedPreviewFiltersData?.deviationType?.map((item) => ({
            label: item.name,
            value: item.code
          })) || []
        }
        loading={consolidatedPreviewFiltersLoading}
      />
      <MultiSelect
        name="consolidatedPreviewFilters.status"
        label="Status"
        placeholder="Selecione..."
        options={
          consolidatedPreviewFiltersData?.status?.map((item) => ({
            label: item.name,
            value: item.code
          })) || []
        }
        loading={consolidatedPreviewFiltersLoading}
      />

      <Box />
      <Box />
      <Box />

      <S.FilterButtons>
        <Button
          colorType="outlineBlue"
          rightIcon={<FilterIcon />}
          onClick={onConsolidatedPreviewDetailsFilters}
          disabled={consolidatedPreviewFiltersLoading}
        >
          Filtrar
        </Button>

        <Button
          colorType="outlineBlue"
          rightIcon={<CloseIcon />}
          onClick={() => {
            if (consolidatedPreviewFiltersData) {
              handleResetFilters()
            } else {
              reset()
            }
            onClearConsolidatedPreviewFilters()
          }}
          disabled={consolidatedPreviewFiltersLoading}
        >
          Limpar
        </Button>
      </S.FilterButtons>
    </RowBox>
  )
}
